import { render, staticRenderFns } from "./CreatesoInvoicecon.vue?vue&type=template&id=bc28527a&scoped=true"
import script from "./CreatesoInvoicecon.vue?vue&type=script&lang=js"
export * from "./CreatesoInvoicecon.vue?vue&type=script&lang=js"
import style0 from "./CreatesoInvoicecon.vue?vue&type=style&index=0&id=bc28527a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc28527a",
  null
  
)

export default component.exports